import React from 'react'
import Trustedpartner from '../components/Trustedpartner';


const DynamicClient = ({customClass}) => {
   const customClass2 = customClass;
    const clientLogos = [
        { src: '/clients/lg1.png', alt: 'Client' },
        { src: '/clients/lg2.png', alt: 'Client' },
        { src: '/clients/lg3.png', alt: 'Client' },
        { src: '/clients/lg6.png', alt: 'Client' },
        { src: '/clients/lg7.png', alt: 'Client' },
        { src: '/clients/lg8.png', alt: 'Client' },
        { src: '/clients/lg10.png', alt: 'Client' },
        { src: '/clients/lg11.png', alt: 'Client' },
        { src: '/clients/lg12.png', alt: 'Client' },
        { src: '/clients/lg13.png', alt: 'Client' },
        { src: '/clients/lg14.png', alt: 'Client' },
        { src: '/clients/lg15.png', alt: 'Client' }
        // Add more logos as needed
      ];
  return (
    <>
    <Trustedpartner logos={clientLogos} customClass={customClass2}/>
    </>
  )
}

export default DynamicClient